import { createFileRoute } from '@tanstack/react-router';
import { DesktopShellPage } from '@/app/layout/DesktopShellPage';

/**
 * Route pro kořenovou cestu (/).
 * Zobrazuje prázdnou plochu s menu – žádná agenda není po načtení otevřená.
 * Tenký wrapper nad app-shell composition.
 */
export const Route = createFileRoute('/')({
  component: DesktopShellPage,
});
